import { useParams, Switch, Route, useRouteMatch, Redirect } from "react-router-dom";

import { useUserProfileContext } from "@/contexts/UserProfileContext";
import { ViewerContext } from "@/tpo/Viewer";

import { ERROR_404_URL, getWardUrl, WARDS_PROFILE_URL, WARDS_TESTS_URL } from "../../core/urls";
import WardOrderRoutes from "./orders";
import WardProfile from "./profile/Profile";
import WardQuestionnaire from "./questionnaire/Questionnaire";
import WardReportsRoutes from "./reports";
import WardTestResults from "./testResults";

function WardView() {
  const match = useRouteMatch();
  const { patientId } = useParams();

  return (
    <ViewerContext.Provider
      value={{
        userId: patientId
      }}
    >
      <Switch>
        <Route path={match.path} exact>
          <Redirect to={getWardUrl(WARDS_PROFILE_URL, { patientId })} />
        </Route>
        <Route path={`${match.path}/profile`} exact component={WardProfile} />
        <Route path={`${match.path}/orders`} component={WardOrderRoutes} />
        <Route path={`${match.path}/tests`} component={WardTestResults} />
        <Route path={`${match.path}/reports`} component={WardReportsRoutes} />
        <Route path={`${match.path}/questionnaire`} exact component={WardQuestionnaire} />
        <Redirect to={getWardUrl(WARDS_TESTS_URL, { patientId })} />
      </Switch>
    </ViewerContext.Provider>
  );
}

export default function WardViewRoutes() {
  const match = useRouteMatch();
  const { patientId } = useParams();

  const { patientProfile } = useUserProfileContext();

  const isGuardian = !!patientProfile?.wards
    ?.map(ward => ward.user.id)
    ?.find(id => patientId == id);

  if (patientProfile && !isGuardian) {
    return <Redirect to={ERROR_404_URL} />;
  }

  return (
    <Switch>
      <Route path={`${match.path}`} component={WardView} />
    </Switch>
  );
}
